import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import img from '../../../assets/img/spinner.png';
var Spinner = /*#__PURE__*/function (_Component) {
  function Spinner(props) {
    var _this;
    _classCallCheck(this, Spinner);
    _this = _callSuper(this, Spinner, [props]);
    _defineProperty(_this, "getContainerClassName", function () {
      var _this$props = _this.props,
        center = _this$props.center,
        right = _this$props.right,
        small = _this$props.small;
      var classNames = 'spinner-container';
      if (center) {
        classNames += ' center';
      }
      if (right) {
        classNames += ' right';
      }
      if (small) {
        classNames += ' small';
      }
      return classNames;
    });
    return _this;
  }
  _inherits(Spinner, _Component);
  return _createClass(Spinner, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.getContainerClassName(),
        key: "spinner"
      }, /*#__PURE__*/React.createElement("div", {
        className: "loading-spinner",
        style: {
          backgroundImage: "url(".concat(img, ")")
        }
      }));
    }
  }]);
}(Component);
export default Spinner;